var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../strings/i18n/i18n';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import ModalHeaderStrip from '../../ui/atoms/ModalHeaderStrip';
import { clearAdditionalInfoState, updateAdditionalInfoView } from '../../redux/additionalInfo/additionalInfo.slice';
import { closeModal, openModal } from '../../redux/ui/ui.slice';
import { Inset } from 'syf-component-library/ui/spacing';
import { AdditionalInfoView } from '../../redux/additionalInfo/typings';
import { Analytics } from '../../helpers/analyticsMiddleware';
import { triggerAnalyticsEvent } from 'syf-js-utilities';
import usePartialUpload from '../../hooks/usePartialUpload';
import DisputeModalHeader from '../../ui/organisms/DisputeModalHeader';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import SLIDE_IN_MODAL_CONTAINER_ID from '../../const/modalContainerIds';
import useSelectedDispute from '../../hooks/useSelectedDispute';
import { ModalType } from '../../redux/ui/typings';
import AdditionalInfoCurrentView from './subcomponents/AdditionalInfoCurrentView';
import AdditionalInfoModalFooter from './subcomponents/AdditionalInfoModalFooter';
import AdditionalInfoTextBanner from './subcomponents/AdditionalInfoTextBanner';
var AdditionalInfo = function () {
    var currentView = useSelector(function (state) { return state; }, shallowEqual).additionalInfo.currentView;
    var hasUserEnteredData = useSelector(function (_a) {
        var additionalInfo = _a.additionalInfo;
        var acceptedFiles = additionalInfo.acceptedFiles, rejectedFiles = additionalInfo.rejectedFiles, userComment = additionalInfo.userComment;
        return acceptedFiles.length || rejectedFiles.length || userComment;
    });
    var _a = usePartialUpload(), isPartialUpload = _a.isPartialUpload, hasNewFiles = _a.hasNewFiles;
    var dispatch = useDispatch();
    var selectedTransaction = useSelectedDispute().selectedTransaction;
    var disputeReason = selectedTransaction.disputeReason;
    var disputeTitle = selectedTransaction === null || selectedTransaction === void 0 ? void 0 : selectedTransaction.merchantName;
    var isMobile = useWindowSize().isLessThanTablet;
    var verticalSpacing = isMobile ? 'large' : 'xlarge';
    var handleCloseModal = function () {
        if (currentView === AdditionalInfoView.CancelConfirmation ||
            currentView === AdditionalInfoView.SubmitConfirmation) {
            dispatch(clearAdditionalInfoState());
            dispatch(closeModal());
            return;
        }
        if (isPartialUpload && !hasNewFiles) {
            dispatch(updateAdditionalInfoView({
                currentView: AdditionalInfoView.SubmitConfirmation
            }));
            return;
        }
        if (hasUserEnteredData) {
            dispatch(updateAdditionalInfoView({
                currentView: AdditionalInfoView.CancelConfirmation
            }));
        }
        else {
            dispatch(clearAdditionalInfoState());
            dispatch(openModal(ModalType.DisputeInfo));
        }
    };
    useEffect(function () {
        triggerAnalyticsEvent({
            pageKind: Analytics.Dispute,
            pageFunction: Analytics.AdditionalInfo,
            pageName: Analytics.Start,
            message: disputeReason
        });
    }, [disputeReason]);
    return (_jsxs(SlideInModalPortal, __assign({ ariaLabel: "Synchrony Disputes Upload Documents and Add Comments Modal", id: "modal", "data-cy": "additional-info-modal", containerId: SLIDE_IN_MODAL_CONTAINER_ID, isOpen: true, escapeModalHandler: handleCloseModal, header: _jsx(DisputeModalHeader, { dataTitle: "dispute-transaction", dataType: "dispute-transaction", dataReason: "x-button", content: t('additionalInfo.headerTitle'), closeModal: handleCloseModal, "data-cy": "upload-docs-header" }), footer: _jsx(AdditionalInfoModalFooter, { handleCloseModal: handleCloseModal }) }, { children: [_jsx(ModalHeaderStrip, { "data-cy": "additional-information-transaction-banner", title: disputeTitle }), _jsx(AdditionalInfoTextBanner, {}), _jsx(Inset, __assign({ vertical: verticalSpacing, respondToBreakpoints: ['medium', 'huge'] }, { children: _jsx(AdditionalInfoCurrentView, {}) }))] })));
};
export default AdditionalInfo;
//# sourceMappingURL=index.js.map